import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ignoreElements } from 'rxjs/operator/ignoreElements';
import { PreferencesService } from '../../../../../app/modules/preferences/preferences.service';
import { ConfigAddMontlyDashbrdMessageComponent } from '../../config-add-montly-dashbrd-message/config-add-montly-dashbrd-message.component';
import { ConfigAddTakeComponent } from '../../config-add-take/config-add-take.component';
import { FormsByCategory_Dashboard, IdNameVM, OverallDashboardVM, OverallDashboard_ChecksCompleted, SiteCodes } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { SafetyGeneraldashboardService } from '../../services/safety-generaldashboard.service';
import { FormActivitiesComponent } from '../form-activities/form-activities.component';
import { IncidentDialogComponent } from '../incident-dialog/incident-dialog.component';
import { IncidentLtiDialogComponent } from '../incident-lti-dialog/incident-lti-dialog.component';
import { IncidentMtiDialodComponent } from '../incident-mti-dialod/incident-mti-dialod.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-safety-general-dashboard',
  templateUrl: './safety-general-dashboard.component.html',
  styleUrls: ['./safety-general-dashboard.component.css']
})
export class SafetyGeneralDashboardComponent implements OnInit {

  constructor(private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    public dialog: MatDialog,
    private _router: Router,
    private readonly _pref: PreferencesService,
    private _safetyConfigService: SafetyConfigService) { }
  monthList: IdNameVM[] = [];
  inputValueMonth: number;
  stateID: number = 0
  OverallDashboard_ChecksCompleted: OverallDashboard_ChecksCompleted
  OverallDashboardVM: OverallDashboardVM[]
  selected = '0';
  siteCodesList: SiteCodes[] = [];
  //dashboard labels
  Inspections
  InspectionQuestions
  Target
  Expected
  isInspectionExpected: boolean
  CheckesWithFails
  TotalChecks
  checksFailedPct = 0
  failedItemsPct = 0
  FailedItems
  TotalItems
  DaysSinceLastFail
  Days
  Label1 = "MTI Free Days"
  Label2 = "LTI  Free Days"
  DaysSinceLastIncidentMTIAndAbove
  DaysSinceLastLTI
  FocusItems
  Positives
  AreasOfImprovement
  Name
  Total
  dataSource = new MatTableDataSource();
  dataSource_ = new MatTableDataSource();
  displayedColumns: string[] = ['Name', 'Total'];
  displayedColumns_: string[] = ['IncidentName', 'IncidentTotal'];
  Take5Target
  Take5Actual
  iscurrentMonth: boolean
  currentactual
  isForward90Checkscompleted: boolean = false
  isForward270Checkscompleted: boolean = false
  isDoneCheckscompleted: boolean = false
  isForward90: boolean = false
  isForward270: boolean = false
  isdone: boolean = false
  iscurrentActual: boolean = false
  Previous12MOntsHours
  Previous12MonthsTRIFR
  IncidentName
  IncidentTotal
  isLoading: boolean = false

  ngOnInit() {
    this.isLoading = true
    this.getMonthList();


  }

  getMonthList() {
    this._safetyGeneraldashboardService.GetMonthsForDashboard().subscribe(res => {

      this.monthList = res
      this.inputValueMonth = 0;
      this.changeValue(0);
      this.loadSiteList();
    });

  }
  reloadfields() {
    this.changeValue(this.inputValueMonth);
  }

  loadSiteList() {
    this._safetyConfigService.getAllSitesList().subscribe(sites => {
      console.log('sitelist', sites)
      this.siteCodesList = sites;
      this.isLoading = false
    });
  }
  changeValue(value: any) {
    let Id: any;
    this.refreshFeilds();
    this.isLoading = true
    Id = this.monthList.filter(item => item.Id == value)[0].Id
    console.log(Id)
    this.inputValueMonth = Id;

    console.log('before state ID', this.stateID)
    console.log('before  ID', Id)

    this.LoadMTILTIData();
    this._safetyGeneraldashboardService.GetOverallDashboard(Id, this.stateID).subscribe(res => {
      console.log(res)

      //checks Completd values
      this.OverallDashboard_ChecksCompleted = res.OD_ChecksCompleted
      this.Inspections = this.OverallDashboard_ChecksCompleted.Inspections
      this.InspectionQuestions = this.OverallDashboard_ChecksCompleted.InspectionQuestions
      this.Target = res.OD_SafetyTargets.Target
      this.Expected = res.OD_SafetyTargets.Expected
      if (this.Inspections < this.Expected) {
        this.isForward90Checkscompleted = true
        this.isForward270Checkscompleted = false
        this.isDoneCheckscompleted = false
      }
      else if (this.Inspections > this.Expected) {
        this.isForward270Checkscompleted = true
        this.isForward90Checkscompleted = false
        this.isDoneCheckscompleted = false
      }
      else if (this.Inspections == this.Expected) {
        this.isDoneCheckscompleted = true
        this.isForward270Checkscompleted = false
        this.isForward90Checkscompleted = false
      }

      //Checks with fails
      this.CheckesWithFails = res.OD_ChecksWithFails.ChecksFailed
      this.TotalChecks = res.OD_ChecksWithFails.TotalChecks
      if (this.TotalChecks != 0) {
        this.checksFailedPct = (this.CheckesWithFails * 100) / this.TotalChecks;
      }
      else {
        this.checksFailedPct = 0
      }



      //Faild Items
      this.FailedItems = res.OD_FailedItems.FailedItems
      this.TotalItems = res.OD_FailedItems.TotalItems
      if (this.TotalItems != 0) {
        this.failedItemsPct = (this.FailedItems * 100) / this.TotalItems
      }
      else {
        this.failedItemsPct = 0
      }

      //Since Last Fail
      this.DaysSinceLastFail = res.DaysSinceLastFail

      //Incident Counts
      this.DaysSinceLastIncidentMTIAndAbove = res.OD_HoursToDate.DaysSinceLastIncidentMTIAndAbove
      this.DaysSinceLastLTI = res.OD_HoursToDate.DaysSinceLastLTI

      //focus Items, Positives, Areas of improvements
      this.FocusItems = res.OD_Messages.FocusItems
      this.Positives = res.OD_Messages.Positives
      this.AreasOfImprovement = res.OD_Messages.AreasOfImprovement


      //Take 5 Target
      this.Take5Target = res.OD_Take5s.Target
      this.Take5Actual = res.OD_Take5s.Actual
      this.iscurrentMonth = res.OD_Take5s.isCurrentMonth
      this.currentactual = res.OD_Take5s.CurrentActual
      if (this.iscurrentMonth == false) {
        if (this.Take5Actual < this.Take5Target) {
          this.isForward90 = true
          this.isForward270 = false
          this.isdone = false
        }
        else if (this.Take5Actual > this.Take5Target) {
          this.isForward270 = true
          this.isForward90 = false
          this.isdone = false
        }
        else {
          this.isdone = true
          this.isForward270 = false
          this.isForward90 = false
        }
      }
      else {
        this.iscurrentActual = true

        if (this.currentactual > this.Take5Actual) {
          this.isForward90 = true
          this.isForward270 = false
          this.isdone = false
        }
        else if (this.currentactual < this.Take5Actual) {
          this.isForward270 = true
          this.isForward90 = false
          this.isdone = false
        }
        else if (this.currentactual == this.Take5Actual) {
          this.isdone = true
          this.isForward270 = false
          this.isForward90 = false
        }
      }

      this.Previous12MOntsHours = res.OD_HoursToDate.HoursToDate
      this.Previous12MonthsTRIFR = res.OD_TRIFRTracking.Last12Month.TRIFR

      this.dataSource_.data = res.OD_Incidents.Incidents
      this.dataSource.data = res.OD_Activities.Activities

      this.isLoading = false
    });
  }

  openConfigAddMonthlyDashMessageDialog() {
    const dialogRef = this.dialog.open(ConfigAddMontlyDashbrdMessageComponent, {
      disableClose: true,
      data: {

      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {

      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  openConfigAddTakeDialog() {
    const dialogRef = this.dialog.open(ConfigAddTakeComponent, {
      disableClose: true,
      data: {

      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {

      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }
  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }

  refreshFeilds() {


    this.Inspections = ""
    this.InspectionQuestions = ""
    this.Target = ""
    this.Expected = ""
    this.CheckesWithFails = ""
    this.TotalChecks = ""
    this.FailedItems = ""
    this.TotalItems = ""
    this.DaysSinceLastFail = ""
    this.DaysSinceLastIncidentMTIAndAbove = ""
    this.DaysSinceLastLTI = ""

    //focus Items, Positives, Areas of improvements
    this.FocusItems = ""
    this.Positives = ""
    this.AreasOfImprovement = ""

    //Take 5 Target
    this.Take5Target = ""
    this.Take5Actual = ""
    this.currentactual = ""


    this.Previous12MOntsHours = ""
    this.Previous12MonthsTRIFR = ""

    this.dataSource_.data = []
    this.dataSource.data = []

  }



  openFormActivitiesComponent(element) {
    const dialogRef = this.dialog.open(FormActivitiesComponent, {
      disableClose: true,
      data: {
        // InspectionID:this.inspectionId
        inputValueMonth: this.inputValueMonth,
        stateID: this.stateID,
        FormCategoryID: element.FormCategoryID,
        FormName: element.Name

      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {

      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }


  openFormIncidentsComponent(element) {
    const dialogRef = this.dialog.open(IncidentDialogComponent, {
      disableClose: true,
      data: {
        // InspectionID:this.inspectionId
        inputValueMonth: this.inputValueMonth,
        stateID: this.stateID,
        IncidentTypeID: element.ID,
        IncidentName: element.Name

      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {

      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  openDialoglastIncidentLTI() {
    const dialogRef = this.dialog.open(IncidentLtiDialogComponent, {
      disableClose: true,
      data: {
        inputValueMonth: this.inputValueMonth,
        stateID: this.stateID,


      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {

      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });

  }
   isnoDataLTI: boolean = true;
  isnoDataMTI: boolean = true;
  FormListLTI: FormsByCategory_Dashboard[] = []
  FormListMTI: FormsByCategory_Dashboard[] = []

  FormListMTILTI: FormsByCategory_Dashboard[] = []

  FormMTI: FormsByCategory_Dashboard;
  FormLTI: FormsByCategory_Dashboard;

  MTIDate: Date;
  LTIDate: Date;

  LoadMTILTIData() {
    this._safetyGeneraldashboardService.GetLastMTIAndLTI(this.stateID).subscribe(res => {
      console.log("LTI MTI", res)
      this.isnoDataLTI = true;
      this.isnoDataMTI = true;

      this.FormListMTILTI = res;
      if (this.FormListMTILTI.length > 0) {
        this.FormListLTI = this.FormListMTILTI.filter(x => x.isMTI == false);
        this.FormListMTI = this.FormListMTILTI.filter(x => x.isMTI == true);

        if (this.FormListLTI.length > 0) {
          this.isnoDataLTI = false;
          this.LTIDate = this.FormListLTI[0].Date;
          this.FormLTI = this.FormListLTI[0];
        } 


        if (this.FormListMTI.length > 0) {
          this.isnoDataMTI = false;
          this.MTIDate = this.FormListMTI[0].Date;
          this.FormMTI = this.FormListMTI[0];
  
  
        }
      }
    })
  }
 


  openForm(form) {
    if (form.IsDigitalForm) {
      //this._router.navigate(['/editdigitalformscomponent', form.Id]);
      //   window.open('/editdigitalformscomponent/' + form.Id, '_blank');
      this._pref.GetReplaceExistingTabStatus().subscribe(res => {
        if (res == "True") {
          this._router.navigate(['/editdigitalformscomponent', form.Id]);
        } else {
          window.open('/editdigitalformscomponent/' + form.Id, '_blank');

        }
      });

    } else {
      //this._router.navigate(['/uploadformedit', form.Id]);
      // window.open('/uploadformedit/' + form.Id, '_blank');

      this._pref.GetReplaceExistingTabStatus().subscribe(res => {
        if (res == "True") {
          this._router.navigate(['/uploadformedit', form.Id]);
        } else {
          window.open('/uploadformedit/' + form.Id, '_blank');

        }
      });

    }
  }


  openDialoglastIncidentMTI() {
    const dialogRef = this.dialog.open(IncidentMtiDialodComponent, {
      disableClose: true,
      data: {
        inputValueMonth: this.inputValueMonth,
        stateID: this.stateID,


      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {

      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });

  }
}
